import { ArrowLeftIcon } from 'components/icons';
import styled from 'styled-components';

export default styled(ArrowLeftIcon)`
  transform: rotateY(180deg);
`;
